import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import Index from '../views/index/Index.vue'

const routes = [
  {
    name: 'Index',
    path: PATHS.BASE_URL,
    component: Index,
  },
  {
    name: 'Register',
    path: PATHS.REGISTER,
    component: () =>
      import(
        /* webpackChunkName: "register" */ '../views/register/Register.vue'
      ),
  },
  {
    name: 'Auth',
    path: PATHS.AUTH,
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Auth.vue'),
  },
  {
    name: 'PasswordRecovery',
    path: PATHS.PASSWORD_RECOVERY,
    component: () =>
      import(
        /* webpackChunkName: "passwordRecovery" */ '../views/auth/PasswordRecovery.vue'
      ),
  },
  {
    name: 'NewPassword',
    path: PATHS.NEW_PASSWORD,
    component: () =>
      import(
        /* webpackChunkName: "newPassword" */ '../views/auth/NewPassword.vue'
      ),
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Roles',
    path: PATHS.ROLES,
    component: () =>
      import(/* webpackChunkName: "roles" */ '../views/roles/Roles.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'DetailsRole',
    path: PATHS.DETAILS_ROLE,
    component: () =>
      import(/* webpackChunkName: "roles" */ '../views/roles/RoleDetails.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'Users',
    path: PATHS.USERS,
    component: () =>
      import(/* webpackChunkName: "users" */ '../views/users/Users.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'DetailsUser',
    path: PATHS.DETAILS_USER,
    component: () =>
      import(/* webpackChunkName: "users" */ '../views/users/UserDetails.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'Courses',
    path: PATHS.COURSES,
    component: () =>
      import(/* webpackChunkName: "courses" */ '../views/courses/Courses.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'DetailsCourse',
    path: PATHS.DETAILS_COURSE,
    component: () =>
      import(
        /* webpackChunkName: "courses" */ '../views/courses/CourseDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ProgressCourse',
    path: PATHS.PROGRESS_COURSE,
    component: () =>
      import(
        /* webpackChunkName: "progress" */ '../views/progress/ProgressCourse.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportUsersProgress',
    path: PATHS.REPORT_USERS_PROGRESS,
    component: () =>
      import(
        /* webpackChunkName: "reports" */ '../views/reports/UsersProgress.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresPJ: true,
    },
  },
  {
    name: 'CertificateAuth',
    path: PATHS.CERTIFICATE_AUTH,
    component: () =>
      import(
        /* webpackChunkName: "certificate" */ '../views/certificate/CertificateAuth.vue'
      ),
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { user, isLoggedIn } = store.getters

  if (isLoggedIn && (to.name === 'Index' || to.name === 'Auth')) {
    return { name: 'Home' }
  }
  if (to.meta.requiresAuth) {
    if (!isLoggedIn && !localStorage.getItem('token')) {
      return { name: 'Auth' }
    }
    if (to.meta.requiresAdmin && to.meta.requiresPJ) {
      if (user.isAdmin !== 1 || user.clientTypePerson !== 1) {
        return { name: 'Unauthorized' }
      }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedIn && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.AUTH)
  }
})

export default router
